import React, { useEffect, useState } from 'react';
import api from '../api';

export default function EtlRuns() {
  const [summary, setSummary] = useState(null);
  const [runs, setRuns]       = useState([]);
  const [errors, setErrors]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    Promise.all([
      api.get('/api/v1/etl/summary'),
      api.get('/api/v1/etl/runs'),
      api.get('/api/v1/etl/errors'),
    ])
      .then(([s, r, e]) => {
        setSummary(s.data);
        setRuns(r.data);
        setErrors(e.data);
        setError(null);
      })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading">Loading...</div>;
  if (error)   return <div className="error">Error: {error}</div>;

  return (
    <>
      {/* Summary metrics */}
      <div className="metrics">
        <div className="metric">
          <div className="metric-label">Last run</div>
          <div className="metric-value" style={{ fontSize: 15 }}>
            {summary?.last_run
              ? new Date(summary.last_run).toLocaleString()
              : '—'}
          </div>
        </div>
        <div className="metric">
          <div className="metric-label">Total runs</div>
          <div className="metric-value">{summary?.total_runs || 0}</div>
        </div>
        <div className="metric">
          <div className="metric-label">Successful</div>
          <div className="metric-value" style={{ color: '#16a34a' }}>
            {summary?.successful || 0}
          </div>
        </div>
        <div className="metric">
          <div className="metric-label">Failed</div>
          <div className="metric-value" style={{ color: (summary?.failed || 0) > 0 ? '#dc2626' : '#1a1a1a' }}>
            {summary?.failed || 0}
          </div>
        </div>
        <div className="metric">
          <div className="metric-label">Total rows inserted</div>
          <div className="metric-value">{(summary?.total_rows || 0).toLocaleString()}</div>
        </div>
        <div className="metric">
          <div className="metric-label">Errors logged</div>
          <div className="metric-value" style={{ color: (summary?.total_errors || 0) > 0 ? '#dc2626' : '#1a1a1a' }}>
            {summary?.total_errors || 0}
          </div>
        </div>
      </div>

      {/* Latest status per server */}
      <div className="card">
        <div className="card-header">
          <div className="card-title">Latest run per server</div>
        </div>
        <table>
          <thead>
            <tr>
              <th>Server</th>
              <th>Last run</th>
              <th>Rows inserted</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {(summary?.latest_per_server || []).map(r => (
              <tr key={r.run_id}>
                <td style={{ fontWeight: 500 }}>{r.source_server}</td>
                <td style={{ color: '#666' }}>{new Date(r.start_time).toLocaleString()}</td>
                <td>{(r.rows_inserted || 0).toLocaleString()}</td>
                <td>
                  <span className={`badge ${r.status === 'SUCCESS' ? 'badge-active' : 'badge-inactive'}`}>
                    {r.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Full run log */}
      <div className="card">
        <div className="card-header">
          <div className="card-title">Run log (last 100)</div>
        </div>
        <table>
          <thead>
            <tr>
              <th>Run ID</th>
              <th>Server</th>
              <th>Started</th>
              <th>Ended</th>
              <th>Rows</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {runs.map(r => (
              <tr key={r.run_id}>
                <td style={{ color: '#999', fontSize: 12 }}>{r.run_id}</td>
                <td style={{ fontWeight: 500 }}>{r.source_server}</td>
                <td style={{ color: '#666', fontSize: 12 }}>{new Date(r.start_time).toLocaleString()}</td>
                <td style={{ color: '#666', fontSize: 12 }}>
                  {r.end_time ? new Date(r.end_time).toLocaleString() : '—'}
                </td>
                <td>{(r.rows_inserted || 0).toLocaleString()}</td>
                <td>
                  <span className={`badge ${r.status === 'SUCCESS' ? 'badge-active' : r.status === 'STARTED' ? '' : 'badge-inactive'}`}>
                    {r.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Error log */}
      {errors.length > 0 && (
        <div className="card">
          <div className="card-header">
            <div className="card-title" style={{ color: '#dc2626' }}>
              Error log ({errors.length})
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>Time</th>
                <th>Server</th>
                <th>Database</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              {errors.map(e => (
                <tr key={e.id}>
                  <td style={{ color: '#666', fontSize: 12 }}>{new Date(e.error_time).toLocaleString()}</td>
                  <td style={{ fontWeight: 500 }}>{e.source_server}</td>
                  <td style={{ color: '#666' }}>{e.database_name}</td>
                  <td style={{ color: '#dc2626', fontSize: 12 }}>{e.error_message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
